import type { ExclusivePlaybackState } from '../lib/connector';

export function normalizeExclusiveStreamError(
  streamError: ExclusivePlaybackState['stream_error'],
): string | null {
  if (typeof streamError !== 'string') return null;
  const trimmed = streamError.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/** End-of-track advance decision for the exclusive engine poller. */
export function shouldExclusivePollerAdvanceTrackEnd(params: {
  state: Pick<ExclusivePlaybackState, 'ended' | 'is_buffering'>;
  playbackState: string;
  effectiveDuration: number;
  effectivePosition: number;
  endAdvancePending: boolean;
}): boolean {
  const {
    state,
    playbackState,
    effectiveDuration,
    effectivePosition,
    endAdvancePending,
  } = params;

  if (endAdvancePending || playbackState === 'paused') return false;

  if (state.ended === true) {
    return playbackState === 'playing' || playbackState === 'stopped';
  }

  if (playbackState !== 'playing') return false;

  // Pre-11.0.172 fallback when ended is absent: position threshold only.
  if (
    state.ended === undefined
    && effectiveDuration > 0
    && effectivePosition >= effectiveDuration
    && !state.is_buffering
  ) {
    return true;
  }

  return false;
}
